define('viewmodels/ProductRiskRating/ProductDetailsPage',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils', 'viewmodels/ProductRiskRating/ProductRiskRatingDashboard'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils,ProductRiskRatingDashboard) {
        var app = require('durandal/app'),
            ko = require('knockout');

        var ProductDetailsVM = {
            activate: activate,
            detached: detached,
            canActivate: ko.observable(true),
            attached: attached,
            appsecurity: appsecurity,
            PageHeaderName: ko.observable(),
            NavigateToDashboard: NavigateToDashboard,
            ProductStatus: ko.observable(),
            DisableControl: ko.observable(false),
            ProductRiskRatingDashboard: ProductRiskRatingDashboard,
            // Products
            getAllFactorsWithSubfactors: getAllFactorsWithSubfactors,
            getSavedResponses: getSavedResponses,
            RiskFactorandSubFactorList: ko.observableArray(),
            selectedResponse: ko.observable(new FactorModel({})),
            SelectedValue: ko.observable(),
            SaveResponse: SaveResponse,
            SaveResponseList: ko.observableArray(),
            // Search 
            SearchResult: SearchResult,
            ClearSearchText: ClearSearchText,
            Query: ko.observable(''),
            // Progress Bar
            BarWidth: ko.observable(0),
            ProgressBar: ProgressBar,
            //Comments
            ShowComments: ShowComments,
            SaveComment: SaveComment,
            ResetComment: ResetComment,
            ClosePopOver: ClosePopOver,
            RcKeypress: RcKeypress,
            RcKeyUp: RcKeyUp,
            ResponseCommentChars: ko.observable(),
            ResponseCommentCharsLimit: ko.observable(2000),

            SelectedValueChangedEvent: SelectedValueChangedEvent,
            responseArray: ko.observableArray(),

            selectedComment: ko.observable(new CommentModel({})),
            selectedCommentResponseType: ko.observable(),
            // Actions 
            showActionsPopup: showActionsPopup,
            btnClickPerformAction: btnClickPerformAction,
            selectedAction: ko.observable("")


        };

        return ProductDetailsVM;


        function detached() {
            try {
                ProductDetailsVM.canActivate(true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in SurveyResponse.js';
                logger.logMessage(msg);
            }
        }

        function activate() {
            try {
                if (ProductDetailsVM.ProductRiskRatingDashboard.SelectedStatus() == undefined) {
                    ProductDetailsVM.canActivate(false);
                    router.navigate("#ProductRiskRating/ProductRiskRatingDashboard", true);
                    return false;
                } else {
                    ClearSearchText();
                    ProductDetailsVM.BarWidth(0);

                    ProductDetailsVM.ProductStatus(ProductDetailsVM.ProductRiskRatingDashboard.SelectedStatus());
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in ProductDetailsPage.js';
                logger.logMessage(msg);
            }

        }

        function attached() {
            if (ProductDetailsVM.ProductRiskRatingDashboard.SelectedStatus() == undefined) {
                ProductDetailsVM.canActivate(false);
                router.navigate("#ProductRiskRating/ProductRiskRatingDashboard", true);
                return false;

            } else {
                ProductDetailsVM.canActivate(true);
                ProductDetailsVM.PageHeaderName('Product Questionnaire');
                getSavedResponses();
                getAllFactorsWithSubfactors();
                ProductDetailsVM.responseArray([]);
                ProductDetailsVM.ResponseCommentChars(2000);
            }
        }
        function NavigateToDashboard(data) {
            try {                
                router.navigate('ProductRiskRating/ProductRiskRatingDashboard', true);
                $('#loadingImgforDashboard').hide();                
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToDashboard() method in ProductDetailsPage.js';
                logger.logMessage(msg);
            }
        }

        function getSavedResponses() {
            try {
                $.ajax({
                    url: "/api/productDashboard/getSavedResponses",
                    type: "GET",
                    data: { "AssignmentID": ProductDetailsVM.ProductRiskRatingDashboard.SelectedPorductAssignmentID() },
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in getAllRiskFactors() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.length > 0) {
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from GetAllData() method in RaComprasionDashboard.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    var msg = 'Exception: ' + error + ' | Source: ajaxFail from GetAllData() method in RaComprasionDashboard.js';
                    logger.logMessage(msg);
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetAllData() method in RaComprasionDashboard.js';
                    logger.logMessage(msg);
                }
            }
        }

        function getAllFactorsWithSubfactors() {
            try {
                $.ajax({
                    url: "/api/productDashboard/getAllFactorsWithSubfactors",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in getAllRiskFactors() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                // Test with local storage
                //var testData = JSON.parse(localStorage.getItem('testData') || []);
                //jsonResult = jsonResult.map((factor) => {
                //    var test = testData.find(testFactor => factor.ID == testFactor.ID);
                //    if (test) {
                //        factor.Value = test.Value;
                //    }
                //    return factor;
                //});

                var mappedFactorList = $.map(jsonResult, function (result) {
                    return new FactorModel(result);
                });
                ProductDetailsVM.RiskFactorandSubFactorList(mappedFactorList);
            }
        }

        function SelectedValueChangedEvent(data, event) {
            event.preventDefault();

            var question = ko.toJS(data);
            question.Value = event.target.value;
            ProductDetailsVM.selectedResponse(question);

            if (ProductDetailsVM.responseArray().length > 0) {
                ProductDetailsVM.responseArray.remove(function (response) { return response.ID == ProductDetailsVM.selectedResponse().ID; });
            }

            ProductDetailsVM.responseArray().push(ProductDetailsVM.selectedResponse());
        }

        function SaveResponse(data, event) {
            var responseArray = ko.toJS(ProductDetailsVM.responseArray);
            var mappedResponses = $.map(responseArray, function (result) {
                return new ResponseModel({ FactorID: result.ID, Response: result.Value, AssignmentID: ProductDetailsVM.ProductRiskRatingDashboard.SelectedPorductAssignmentID() });
            });
            var responses = ko.toJS(mappedResponses)

            //Test with local storage
            localStorage.setItem('testData', JSON.stringify(ko.toJS(ProductDetailsVM.responseArray)));

            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = $("input[name='__RequestVerificationToken']").val();

            try {

                $.ajax({
                    url: "/api/productDashboard/saveResponses",
                    contentType: 'application/json',
                    data: JSON.stringify(responses),
                    type: "POST",
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);

                function ajaxSuccess(jsonResult, success) {

                }

                function ajaxFail(error, status) {
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addAttribute() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }
        }

        // Search 
        function SearchResult() {
            try {
                var searchedList = ko.computed(function () {
                    var q = ProductDetailsVM.Query();
                    if (q != "") {
                        return ProductDetailsVM.RiskFactorandSubFactorList().filter(function (i) {
                            return i.Name().toLowerCase().indexOf(q.toLowerCase()) >= 0;
                        });
                    }
                });

                for (var i = 0; i < ProductDetailsVM.RiskFactorandSubFactorList().length; i++) {
                    ProductDetailsVM.RiskFactorandSubFactorList()[i].IsVisibleforSearch(false);
                }

                if (ProductDetailsVM.Query() != undefined && ProductDetailsVM.Query() == "") {
                    //for empty keyboard input
                    for (var i = 0; i < ProductDetailsVM.RiskFactorandSubFactorList().length; i++) {
                        ProductDetailsVM.RiskFactorandSubFactorList()[i].IsVisibleforSearch(true);
                    }
                }
                if (searchedList() != undefined) {
                    for (var j = 0; j < searchedList().length; j++) {
                        for (var i = 0; i < ProductDetailsVM.RiskFactorandSubFactorList().length; i++) {
                            if (ProductDetailsVM.RiskFactorandSubFactorList()[i].ID == searchedList()[j].ID) {
                                ProductDetailsVM.RiskFactorandSubFactorList()[i].IsVisibleforSearch(true);
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SearchResult() method in ProductDetailPage.js';
                logger.logMessage(msg);
            }
        }

        function ClearSearchText() {
            $('#searchFeature').val('');
        }

        // Progress Bar 
        function ProgressBar() {
            try {
                var elem = document.getElementById("myBar");
                var width = 0;
                width = width + ProductDetailsVM.BarWidth();
                elem.style.width = width + '%';
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ProgressBar() method in ProductDetailsPage.js';
                logger.logMessage(msg);
            }
        }
        ko.applyBindings(ProductDetailsVM, document.getElementById('myBar'));

        // Comments 
        function ShowComments(Type, data, event) {
            try {
                var selectedQuestion = $(this).parent().prevObject[0].ID;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowComments() method in ProductDetailsPage.js';
                logger.logMessage(msg);
            }
        }



        function ClosePopOver() {

        }

        function RcKeypress(data, event) {
            try {
                if (event.which == 16 || event.which == 17 || event.which == 18 || (event.which >= 112 && event.which <= 123) || (event.which >= 35 && event.which <= 40) || event.which == 46 || event.which == 8)
                    return true;
                else {
                    if (event.currentTarget.value.length >= ProductDetailsVM.ResponseCommentCharsLimit())
                        return false;
                    else
                        return true;
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RcKeypress() method in ProductDetailsPage.js';
                logger.logMessage(msg);
            }
        }

        function RcKeyUp(data, event) {
            try {
                ProductDetailsVM.ResponseCommentChars(ProductDetailsVM.ResponseCommentCharsLimit() - event.currentTarget.value.length);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RcKeyUp() method in ProductConfigurationPage.js';
                logger.logMessage(msg);
            }
        }

        function SaveComment() {

        }

        function ResetComment() {

        }

        // Actions 

        function showActionsPopup() {
            $('#ActionsPopUp').modal('show');
        }

        function btnClickPerformAction() {

            if (ProductDetailsVM.selectedAction() === "NA") {
                alert("Move to NA List");
            } else {
                alert("Move to Completed List");
            }
        }

        // Models 

        function FactorModel(item) {
            try {
                var self = this;
                self.ID = item.ID;
                self.AssignmentID = item.AssignmentID;
                self.Name = ko.observable(item.Name);
                self.ResponseTypes = ko.observable(item.ResponseTypes);
                self.IsVisibleforSearch = ko.observable(true);
                self.Value = ko.observable(item.Value || '');
                var mappedSubFactorList = $.map(item.SubFactors, function (result) {
                    return new SubFactorModel(result);
                });

                self.SubFactors = mappedSubFactorList;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FactorModel() method in ProductDetailsPage.js';
                logger.logMessage(msg);
            }
        }

        function SubFactorModel(item) {
            try {
                var self = this;
                self.ID = item.ID;
                self.Name = ko.observable(item.Name);
                self.ResponseTypes = ko.observable(item.ResponseTypes);
                self.isSelected = ko.observable(item.isSelected || false);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubFactorModel() method in ProductDetailsPage.js';
                logger.logMessage(msg);
            }
        }

        function CommentModel(item) {
            var self = this;
            self.ID = item.ID;
            self.QuestionID = item.QuestionID;
            self.CommentText = ko.observable(item.CommentText);
            self.ResponseType = ko.observable(item.ResponseType);
        }

        function ResponseModel(item) {
            var self = this;
            self.AssignmentID = item.AssignmentID;
            self.FactorID = item.FactorID,
                self.Response = ko.observable(item.Response)
        }

    });
